export default {
    en: {
        dates: 'Dates',
        attendanceStatus: 'Attendance Status',
        keyword: 'Keyword',
        statusTips: 'Attendance Status',
        keywordTips: 'Name/Employee ID/Department',
        startTime: 'Start',
        endTime: 'End',
        rangeSeparator: '-',
        search: 'Search',
        reset: 'Reset',
        export: 'Export',
        name: 'Name',
        jobNum: 'Employee ID',
        department: 'Department',
        date: 'Date',
        firstCheck: 'First Time',
        lastCheck: 'Last Time',
        workingHours: 'Work(H)',
        overtimeDuration: 'Overtime(H)',
        operation: 'Operation',
        view: 'Detail',
        total: 'Total {msg} Items',
        normal: 'Normal',
        late: 'Late',
        earlyDeparture: 'Early Departure',
        absence: 'Absence',
        lateEarly: 'Late & Early Departure',
    },
    zh: {
        dates: '时间范围',
        attendanceStatus: '考勤状态',
        keyword: '名字/员工ID/部门',
        statusTips: '考勤状态',
        keywordTips: '请输入关键词',
        startTime: '开始',
        endTime: '结束',
        rangeSeparator: '-',
        search: '搜索',
        reset: '重置',
        export: '导出',
        name: '姓名',
        jobNum: '工号',
        department: '部门',
        date: '日期',
        firstCheck: '首次打卡',
        lastCheck: '末次打卡',
        workingHours: '工作时长（小时）',
        overtimeDuration: '加班时长（小时）',
        operation: '操作',
        view: '查看',
        total: '总共 {msg} 条',
        normal: '正常',
        late: '迟到',
        earlyDeparture: '早退',
        absence: '缺勤',
        lateEarly: '迟到&早退',
    },
};
